import useAuthenticationProgressStep from './useAuthenticationProgressStep';

export default useAuthenticationProgressStep;
